import { VERA_PRIVACY_NOTE, VERA_PRIVACY_NOTE_SHORT } from '../../constants/vera';

export const PRESET_PROMPTS: string[] = [
  'What are the key risks associated with this opportunity?',
  'Has the sponsor done a development like this before?',
  'What is the repayment strategy for this opportunity?',
];

export const DISCLAIMER_POINTS = [
  `Your Privacy – ${VERA_PRIVACY_NOTE}`,
  'Not Financial Advice – The AI responses do not constitute financial, investment, or legal advice. Fides does not provide recommendations or endorse any investment.',
  'Experimental Feature – This tool is in early release and may produce incomplete, inaccurate, or unexpected responses. We welcome your feedback to improve it.',
  'Your Responsibility – You remain responsible for performing your own research and due diligence before making any investment decisions. Always verify information independently.',
];

export const FOOTER_POINTS = [
  VERA_PRIVACY_NOTE_SHORT,
  'Vera does not provide financial advice. Fides does not provide investment recommendations.',
  'Vera is still learning: you may see incomplete or unexpected answers. Your feedback helps us improve.',
  'Do your own research: always verify information and perform your own due diligence before making decisions.',
];

export const AI_ERROR_MESSAGE = 'Sorry, Vera had trouble getting a response. Please try again.';
